module.exports = __webpack_public_path__ + "img/1495555657.e62c33e3.jpg";